import type { Fish } from './fish';

export interface BehaviorCounts {
    wandering: number;
    shoaling: number;
    chasing: number;
    fleeing: number;
    following: number;
}

export function emptyCounts(): BehaviorCounts {
    return { wandering: 0, shoaling: 0, chasing: 0, fleeing: 0, following: 0 };
}

export function countBehaviors(creatures: readonly Fish[]): BehaviorCounts {
    const out = emptyCounts();
    for (const fish of creatures) {
        switch (fish.currentBehavior) {
            case 'wander':
                out.wandering++;
                break;
            case 'shoal':
                out.shoaling++;
                break;
            case 'chase':
                out.chasing++;
                break;
            case 'flee':
                out.fleeing++;
                break;
            case 'follow':
                out.following++;
                break;
        }
    }
    return out;
}

const ORDER: readonly { key: keyof BehaviorCounts; label: string }[] = [
    { key: 'wandering', label: 'wandering' },
    { key: 'shoaling', label: 'shoaling' },
    { key: 'chasing', label: 'chasing' },
    { key: 'fleeing', label: 'fleeing' },
    { key: 'following', label: 'following' },
];

export function formatCensus(counts: BehaviorCounts): string {
    const parts: string[] = [];
    for (const { key, label } of ORDER) {
        const v = counts[key];
        if (v > 0) parts.push(`${String(v)} ${label}`);
    }
    return parts.join(' · ');
}
